import React from 'react';
import LocalizedStaticPage from './LocalizedStaticPage';

const ConsumerHealthData = () => <LocalizedStaticPage page="health" />;
export default ConsumerHealthData;
